import { combineReducers, Reducer } from "redux";
import userReducer from "./reducers/userReducer";
import checklistReducer from "./reducers/checklistReducer";
import defectsReducer from "./reducers/defectsReducer";
import mastersReducer from "./reducers/mastersReducer";
import repairsReducer from "./reducers/repairsReducer";
import deffectReportByVesselReducer from "./reducers/dashboardReducer";
import accountReducer from "./reducers/accountReducer";
const appReducers = combineReducers({
  user: userReducer,
  checklist: checklistReducer,
  defects: defectsReducer,
  masters: mastersReducer,
  repairs: repairsReducer,
  dashboard: deffectReportByVesselReducer,
  account: accountReducer,
});

// for reseting root reducer on logout
const rootReducer = (state, action) => {
  return appReducers(state, action);
};

export default rootReducer;
